import { OPTIMIZELY_FEATURE_FLAGS_KEYS, PARTNERS_SCHEDULE_LIST_V2 } from 'components/Optimizely/Optimizely.features';

import { useIsScheduleV2FeatureEnabled } from './useIsScheduleV2FeatureEnabled';

export function useIsScheduleListV2Enabled() {
  return useIsScheduleV2FeatureEnabled(OPTIMIZELY_FEATURE_FLAGS_KEYS[PARTNERS_SCHEDULE_LIST_V2]);
}
